import React, {
  ButtonHTMLAttributes,
  PropsWithChildren,
  useState,
} from 'react';
import { Tooltip } from '@/Components/Tooltip';
import useTrackingHook from '@/Hooks/useTrackingHook';
import useRoute from '@/Hooks/useRoute';
import useTypedPage from '@/Hooks/useTypedPage';

type Props = {
  className?: string;
  url?: string;
} & PropsWithChildren<ButtonHTMLAttributes<HTMLButtonElement>>;

export default function CopyUrlButton({ children, url, ...props }: Props) {
  const [message, setMessage] = useState<string>('Copy URL');
  const [tooltipOpen, setTooltipOpen] = useState<boolean>(false);
  const { track } = useTrackingHook();
  const { file } = useTypedPage<{ file: App.Data.FileData }>().props;
  const route = useRoute();

  const handleClick = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    try {
      let proxiedLink;
      if (url) {
        proxiedLink = url;
      } else {
        proxiedLink = route('snippet.show', file.id).replace(
          'app.codewp.ai',
          'codewp.ai',
        );
      }
      await navigator.clipboard.writeText(proxiedLink);
      track('file:copied_link');
      setMessage('Copied!');
    } catch (err) {
      setMessage('Error');
    }
    setTooltipOpen(true);
  };

  return (
    <Tooltip message={message} open={tooltipOpen} onOpenChange={setTooltipOpen}>
      <button onClick={handleClick} {...props}>
        {children}
      </button>
    </Tooltip>
  );
}
